import { atom } from "recoil";
import { useDistanceOfPointsStepQuery } from "../../generated/graphql";

type DistanceOfPointsStepQueryStateType = Pick<ReturnType<typeof useDistanceOfPointsStepQuery>, 'data' | 'loading'>;
export const distanceOfPointsStepQueryState = atom<DistanceOfPointsStepQueryStateType>({
    key: "distanceOfPointsStepQueryState",
    default: { data: undefined, loading: true } as DistanceOfPointsStepQueryStateType,
});
